import { EstadoProductosAnual } from "../../bussines/entities/EstadisticasCRM.entity";

export class EstadoProductosAnualModel implements EstadoProductosAnual {
    constructor(
        public mes: number,
        public estado: string,
        public nroProductos: number
    ) { }

    serialize(): EstadoProductosAnual {
        return {
            mes: this.mes,
            estado: this.estado,
            nroProductos: this.nroProductos
        }
    }

    static deserialize(entity: EstadoProductosAnual): EstadoProductosAnualModel {
        return new EstadoProductosAnualModel(
            entity.mes ?? '',
            entity.estado ?? '',
            entity.nroProductos ?? ''
        );
    }
}